import {reduce} from "@cranq/object-utils";
import {NodeDefs} from "../parser/definition/types/NodeDefs";
import {compileDictionary} from "./utils/compileDectionary";
import {nodeNameToFactoryId} from "./utils/nodeNameToFactoryId";

export function compileFactoryLookup(
  nodeDefs: NodeDefs
): string {
  return compileDictionary(reduce(nodeDefs, (result, nodeDef, nodeName) => {
    result[nodeName] = nodeNameToFactoryId(String(nodeName));
    return result;
  }, {} as Record<string, string>));
}
